/*
 * Cart promo line + BOGO helper (settings in snippets/zerno-cart-promo.liquid).
 *
 * BOGO helper: when someone enters BOGO with fewer items than it needs,
 * Shopify keeps the code on the cart but marks it "not applicable", and the
 * theme shows a bare "Discount not applicable". This hides that message and
 * shows a "1 of 2" bar with best sellers to add instead. The code stays saved,
 * so it applies by itself once the cart has enough items, and the helper
 * disappears. Any other code keeps the theme's normal message.
 *
 * Everything is decided from the real cart (/cart.js), never from what is on
 * screen, so it is also right after a reload or when the drawer is reopened.
 *
 * Promo line: hidden once its code is applied, and while the helper shows.
 */
(function () {
  var C = window.zernoBogoNudge;
  if (!C || window.__zernoBogoNudge) return;
  window.__zernoBogoNudge = true;

  var CODES = (C.codes || [])
    .map(function (c) { return String(c || '').trim().toUpperCase(); })
    .filter(Boolean);
  var MIN = Math.max(2, Number(C.min) || 2);
  var lastTried = '';
  var timer = null;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function getCart() {
    return fetch(root() + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(function (r) { return r.json(); });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[ch];
    });
  }

  function money(cents) {
    var out = '';
    try {
      if (window.theme && typeof window.theme.formatMoney === 'function') {
        out = window.theme.formatMoney(cents, window.theme.moneyFormat || '${{amount}}');
      }
    } catch (e) {}
    if (!out) out = '$' + (cents / 100).toFixed(2);
    return String(out).replace(/\.00(?!\d)/, '').replace(/\s*USD/i, '');
  }

  function isHelperCode(code) {
    return CODES.indexOf(String(code || '').trim().toUpperCase()) > -1;
  }

  // The free gift (snippets/mystery-gift.liquid) never counts towards BOGO.
  function isGift(item) {
    var g = window.theme && window.theme.mysteryGift;
    var giftProduct = g ? Number(g.productId) || 0 : 0;
    return Boolean(
      (item.properties && item.properties._mystery_gift) ||
      (giftProduct && Number(item.product_id) === giftProduct)
    );
  }

  /* ---------- the helper ---------- */

  function cardHtml(p) {
    var avail = p.v.filter(function (v) { return v.a; });
    var from = Math.min.apply(null, avail.map(function (v) { return v.p; }));
    var oneId = p.single || avail.length === 1 && p.v.length === 1 ? avail[0].id : '';
    var img = p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="300" height="300">' : '';
    var add = '<button type="button" class="zbogo__add" data-zbogo-add="' + oneId + '" aria-label="Add ' + esc(p.title) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>Add</span></button>';
    var pick = oneId ? '' :
      '<div class="zbogo__pick" hidden><div class="zbogo__ph"><small>Pick length</small>' +
      '<button type="button" class="zbogo__x" data-zbogo-x aria-label="Close">&times;</button></div><div class="zbogo__ls">' +
      p.v.map(function (v) {
        return '<button type="button" data-zbogo-v="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
      }).join('') + '</div></div>';
    var name = '<a class="zbogo__nm" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
    var price = '<p class="zbogo__pc">' + money(from) + '</p>';

    if (C.layout === 'list') {
      return '<div class="zbogo__c"><a class="zbogo__im" href="' + esc(p.url) + '" tabindex="-1">' + img + '</a>' +
        '<div>' + name + price + '</div>' + add + pick + '</div>';
    }
    return '<div class="zbogo__c"><div class="zbogo__im"><a href="' + esc(p.url) + '" tabindex="-1">' + img + '</a>' +
      add + pick + '</div>' + name + price + '</div>';
  }

  function render(box, show, cart, count) {
    if (!show) {
      box.hidden = true;
      box.innerHTML = '';
      box.removeAttribute('data-sig');
      return;
    }
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var picks = (C.products || []).filter(function (p) {
      return !inCart[p.id] && p.v && p.v.some(function (v) { return v.a; });
    }).slice(0, 3);

    // Same state as already drawn: leave it, so an open length picker survives.
    var sig = count + '|' + picks.map(function (p) { return p.id; }).join(',');
    if (box.getAttribute('data-sig') === sig && !box.hidden) return;

    var bar = '';
    for (var k = 0; k < MIN; k++) bar += '<i' + (k < count ? ' class="is-on"' : '') + '></i>';
    var html = '<div class="zbogo__hd"><b>' + esc(C.heading) + '</b><span>' + count + ' of ' + MIN + '</span></div>' +
      '<div class="zbogo__bar">' + bar + '</div>';
    if (picks.length) {
      html += '<div class="zbogo__k">' + esc(C.label) + '</div><div class="zbogo__list">' + picks.map(cardHtml).join('') + '</div>';
    }
    box.className = 'zbogo' + (C.layout === 'list' ? ' zbogo--list' : '');
    box.innerHTML = html;
    box.setAttribute('data-sig', sig);
    box.hidden = false;
  }

  function run() {
    var boxes = document.querySelectorAll('[data-zbogo]');
    var lines = document.querySelectorAll('[data-zcpromo]');
    if (!boxes.length && !lines.length) return;

    getCart().then(function (cart) {
      var codes = cart.discount_codes || [];
      var waiting = codes.some(function (d) { return isHelperCode(d.code) && d.applicable === false; });
      var helperApplied = codes.some(function (d) { return isHelperCode(d.code) && d.applicable === true; });
      var count = cart.items.reduce(function (n, i) { return isGift(i) ? n : n + i.quantity; }, 0);
      var show = C.on && CODES.length > 0 && waiting && count > 0 && count < MIN;

      Array.prototype.forEach.call(boxes, function (box) { render(box, show, cart, count); });

      Array.prototype.forEach.call(lines, function (line) {
        var code = String(line.getAttribute('data-zcpromo') || '').toUpperCase();
        var applied = code && codes.some(function (d) { return d.applicable && String(d.code).toUpperCase() === code; });
        line.hidden = Boolean(show || applied);
      });

      // The helper replaces "Discount not applicable". The theme also keeps
      // re-showing that message on every redraw after a failed attempt, even
      // once BOGO has applied, so it stays hidden then too. Any other code's
      // message is left alone.
      var keepHidden = show || (helperApplied && isHelperCode(lastTried));
      Array.prototype.forEach.call(document.querySelectorAll('[data-discount-error-message]'), function (err) {
        if (keepHidden) {
          err.classList.add('hidden');
        } else if (err.hasAttribute('data-zbogo-hid')) {
          err.classList.remove('hidden');
        }
        err.removeAttribute('data-zbogo-hid');
      });
    }).catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  }

  // Right after BOGO is applied the theme shows its error before the cart is
  // re-read. Hide it straight away so it never flashes; run() puts it back if
  // the helper does not take over.
  function hideFlash() {
    if (!isHelperCode(lastTried)) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-discount-error-message]'), function (err) {
      if (!err.classList.contains('hidden')) {
        err.classList.add('hidden');
        err.setAttribute('data-zbogo-hid', '');
      }
    });
  }

  /* ---------- adding a suggested product ---------- */

  function add(variantId, btn) {
    var box = btn.closest('[data-zbogo]');
    if (box) box.classList.add('is-busy');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [{id: Number(variantId), quantity: 1}]}),
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); })
      .then(function () {
        // The cart page is rendered server-side; the drawer redraws itself.
        if (document.querySelector('cart-element[data-cart-page]')) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
      })
      .catch(function () { if (box) box.classList.remove('is-busy'); });
  }

  function closePickers(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.zbogo__pick'), function (p) {
      if (p !== except) p.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.zbogo__pick, [data-zbogo-add]')) closePickers(null);

    var t = e.target.closest('[data-zbogo-add], [data-zbogo-v], [data-zbogo-x]');
    if (!t) return;

    e.preventDefault();
    if (t.hasAttribute('data-zbogo-x')) { closePickers(null); return; }
    if (t.hasAttribute('data-zbogo-v')) { add(t.getAttribute('data-zbogo-v'), t); return; }

    var id = t.getAttribute('data-zbogo-add');
    if (id) { add(id, t); return; }

    // More than one length: open the length picker on this card.
    var card = t.closest('.zbogo__c');
    var pick = card && card.querySelector('.zbogo__pick');
    if (!pick) return;
    closePickers(pick);
    pick.hidden = !pick.hidden;
  });

  // Remember which code was just tried. The theme empties the code box as soon
  // as Apply is clicked, so this reads it in the capture phase, before that.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-apply-discount]') : null;
    if (!b) return;
    var widget = b.closest('[data-cart-widget]') || document;
    var input = widget.querySelector('[data-discount-input]');
    lastTried = input ? input.value.trim().toUpperCase() : '';
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-discount-input]')) {
      lastTried = e.target.value.trim().toUpperCase();
    }
  }, true);

  // Every drawer redraw ends with theme:cart:added; the first opening of the
  // drawer fires theme:cart:loaded.
  ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:open', 'theme:cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { hideFlash(); schedule(); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
